/*
* A DataLayer wrapper component that is used to enhance normal DataLayers (for example TileLayer)
* with basic functionality like loading the config file. We wait until the config got loaded,
* then we render the passed DataLayer.
*/

import React from 'react';
import Axios from '../../../core_modules/AxiosCache';

import { setTimeNavigation, setBufferSize, setIdleMode } from '../../TimingHandler/TimingState';

const wrapDataLayer = DataLayer =>
  class DataLayerWrapper extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        configLoaded: false,
        config: null
      };
      this.hasUnmounted = false;
    }

    componentDidMount() {
      if (this.props.toggleLoadingIndicator) {
        this.props.toggleLoadingIndicator(true);
      }
      Axios.get(this.props.url)
        .then(res => this.onConfigLoad(res.data))
        .catch(err => { throw err; });
    }

    componentWillUnmount() {
      // TODO: abort pending requests here
      this.hasUnmounted = true;
    }

    onConfigLoad(config) {
      // TODO: this is an antipattern and should be rewritten
      // https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html
      // https://gist.github.com/mzabriskie/ec3a25dd45dfa0de92c2
      if (this.props.store) {
        this.props.store.dispatch(setIdleMode(true));
      }
      if (this.props.toggleLoadingIndicator) {
        this.props.toggleLoadingIndicator(false);
      }
      if (this.props.timeConnected) {
        this.props.store.dispatch(setTimeNavigation(config));

        const size = config.runs[0].timesteps.length;
        this.props.store.dispatch(setBufferSize(size));
      }

      if (!this.hasUnmounted) {
        if (this.props.overlaySettingsHandler) {
          this.props.overlaySettingsHandler(config);
        }
        this.setState({
          config,
          configLoaded: true
        });
      }
    }

    render() {
      const { timeConnected, currentTimestamp } = this.props;
      return (
        this.state.configLoaded && (!timeConnected || (timeConnected && currentTimestamp)) ? <DataLayer config={this.state.config} {...this.props} /> : null
      );
    }
  };

export default wrapDataLayer;



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/Utils/Wrapper.js
 **/